import { QuestionMarkCircleIcon } from '@heroicons/react/outline';
import classNames from 'classnames';
import TooltipLight from './TooltipLight';

type InsightsMetricCardProps = {
  label: string;
  tooltip: string;
  value: number | undefined;
  loading: boolean;
  error: boolean;
};

const InsightsMetricCard = ({
  label,
  tooltip,
  value,
  loading,
  error,
}: InsightsMetricCardProps) => {
  const showSkeleton = loading && value === undefined;

  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center gap-y-2 rounded-lg border border-neutral-75 p-6',
        'transition-opacity duration-300',
        { 'opacity-50': loading && !showSkeleton },
      )}
    >
      {error ? (
        <div className="font-sans text-caption text-red-100">
          Couldn&apos;t load
        </div>
      ) : showSkeleton ? (
        <div
          data-testid="insights-metric-skeleton"
          className="h-9 w-16 animate-pulse rounded bg-neutral-50"
        />
      ) : (
        <div className="whitespace-nowrap font-sans text-title-small font-medium text-green-150">
          {value === undefined ? '—' : value.toLocaleString()}
        </div>
      )}
      <div className="big-label flex items-center gap-x-1 whitespace-nowrap font-sans font-medium text-green-150">
        {label}
        <TooltipLight
          content={<div className="max-w-xs whitespace-normal">{tooltip}</div>}
          placement="top"
        >
          <span role="img" aria-label={tooltip} className="flex">
            <QuestionMarkCircleIcon
              className="h-4 w-4 text-neutral-110"
              aria-hidden="true"
            />
          </span>
        </TooltipLight>
      </div>
    </div>
  );
};

export default InsightsMetricCard;
